import { cn } from "@newxsystems/shared";
import { RichTextHtml } from "../../../../cms/components/RichTextHtml";
import { getTootSectionSpacing } from "../../../layout/toot-section-spacing";
import { TootBlogPostCard } from "../TootBlogPostCard/TootBlogPostCard";
import type { ITootBlogPostsGridProps } from "./TootBlogPostsGrid.props";

export const TootBlogPostsGrid = ({
  anchorId,
  emptyText,
  eyebrow,
  heading,
  parentClass,
  posts,
  spacing,
  subheading,
}: ITootBlogPostsGridProps) => {
  const headingId = heading && anchorId ? `${anchorId}-heading` : undefined;

  if (!eyebrow && !heading && !subheading && !posts.length && !emptyText) return null;

  return (
    <section
      aria-labelledby={headingId}
      className={cn(
        "relative overflow-hidden text-toot-foreground",
        getTootSectionSpacing(spacing),
        parentClass,
      )}
      id={anchorId ?? undefined}
    >
      <div className="toot-container">
        {eyebrow || heading || subheading ? (
          <header className="mb-10 max-w-4xl md:mb-14">
            {eyebrow ? <p className="toot-eyebrow mb-4">{eyebrow}</p> : null}
            {heading ? (
              <h2 className="toot-heading-section" id={headingId}>
                {heading}
              </h2>
            ) : null}
            {subheading ? (
              <RichTextHtml className="toot-subheading mt-5 max-w-2xl" html={subheading} />
            ) : null}
          </header>
        ) : null}
        {posts.length ? (
          <ul className="grid list-none gap-5 p-0 md:grid-cols-2 lg:gap-6 xl:grid-cols-3">
            {posts.map((post, index) => (
              <li className="min-w-0" key={post.id}>
                <TootBlogPostCard post={post} priority={index < 3} />
              </li>
            ))}
          </ul>
        ) : emptyText ? (
          <p className="rounded-[var(--toot-radius-card)] border border-dashed border-toot-grid-strong bg-card p-6 text-toot-muted">
            {emptyText}
          </p>
        ) : null}
      </div>
    </section>
  );
};

TootBlogPostsGrid.displayName = "Content::TootBlogPostsGrid";
